import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import SwiperCore from "swiper";
import { Avatar } from "@mui/material";
import { PRIMARY_COLOR_MediumRoyalBlue } from "../../../constants/Colors";
import { getAPIEndpointUrl } from "../../../utils/ServerRequestModifier";

SwiperCore.use([Navigation, Autoplay]);

export default function ProjectSlider({ selectedProject }) {
  const navigationStyles = {
    color: PRIMARY_COLOR_MediumRoyalBlue,
  };

  return (
    <>
      <Swiper
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        className="mySwiper"
        style={{width: '100%'}}
      >
        {selectedProject?.galleryImages?.map((slide, index) => {
          return (
            <SwiperSlide key={`slide-${index}`}>
              <Avatar
                sx={{ width: "100%", height: "100%", borderRadius: "0px" }}
                src={getAPIEndpointUrl() + slide.src}
                alt={slide.title}
              />
            </SwiperSlide>
          );
        })}
        <div className="swiper-button-prev" style={navigationStyles}></div>
        <div className="swiper-button-next" style={navigationStyles}></div>
      </Swiper>
    </>
  );
}

